export const formatThousands = (
  n: number,
  isHtml = false,
  toFixed = 2
): string =>
  Number(n)
    .toFixed(toFixed)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${isHtml ? '&nbsp;' : ' '}`)
    .replace('.', ',');
